import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { routes } from './router/routesMap';
import './assets/reactToastify.scss';
import './assets/normalaze.scss';
import './assets/global.scss';
import { ButtonApi } from './components/ChangeAPI';
import { themeOptions } from './theme';
import { Maintenance } from './pages/errors/Maintenance';
import { useMaintenanceStatus } from './hooks/useMaintenanceStatus';
import { addressesSign } from './addresses/sign';

const theme = createTheme(themeOptions);

const router = createBrowserRouter(routes);

function App() {
  const { isOnMaintenance } = useMaintenanceStatus();
  useEffect(() => {
    const pathnameRaw = typeof window !== 'undefined' ? window.location.pathname : '';
    const pathname =
      pathnameRaw !== '/' && pathnameRaw.endsWith('/')
        ? pathnameRaw.slice(0, -1)
        : pathnameRaw;
    const isPublicSignOrRoot =
      pathname === '/' || pathname === addressesSign.signPath;

    if (isPublicSignOrRoot) {
      return;
    }


  }, []);
  if (isOnMaintenance === null) return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ButtonApi />
    </ThemeProvider>
  )

  if (isOnMaintenance) return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <Maintenance />
      </CssBaseline>
      <ToastContainer />
      <ButtonApi />
    </ThemeProvider>
  )
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <RouterProvider router={router} />
      </CssBaseline>
      <ToastContainer />
      <ButtonApi />
    </ThemeProvider>
  );
}

export default App;
